import { useQuery } from "@apollo/client";
import { QR_GET_REVIEW_RATING_DISTRIBUTION } from "../graphQl/ReviewAPI";

/**
 * Répartition des notes (1 à 5 étoiles), calculée côté controller : remplace
 * l'ancien fetch de la liste complète des avis (jusqu'à 200, commentaires et
 * auteurs inclus) juste pour compter les notes.
 */
export const useReviewRatingDistribution = (tripPublicationId, options = {}) => {
  const { enabled = true } = options;

  const { data, loading, error } = useQuery(QR_GET_REVIEW_RATING_DISTRIBUTION, {
    variables: { tripPublicationId },
    skip: !enabled || !tripPublicationId,
    fetchPolicy: "cache-first",
  });

  const response = data?.QR_GET_REVIEW_RATING_DISTRIBUTION;
  const counts = response?.data?.counts ?? [];

  return {
    loading,
    error: error || response?.error || null,
    counts,
    totalElements: response?.data?.totalElements ?? 0,
  };
};
